document.querySelectorAll('.read-more').forEach(el => {
    const children = [...el.children];
    if (children.length <= 3) return;

    const readMore = el.dataset.readMore;
    const readLess = el.dataset.readLess;

    const btn = document.createElement('button');
    btn.className = 'read-more-btn mt-4';
    btn.innerHTML = `
        <span class="read-more-btn__text">${readMore}</span>
        <svg class="read-more-btn__chevron" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M1 1L5 5L9 1" stroke="#FFB500" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;

    el.appendChild(btn);

    btn.addEventListener('click', () => {
        el.classList.toggle('expanded');
        const expanded = el.classList.contains('expanded');
        btn.querySelector('.read-more-btn__text').textContent = expanded ? readLess : readMore;
        btn.querySelector('.read-more-btn__chevron').style.transform = expanded ? 'rotate(180deg)' : 'rotate(0deg)';
    });
});